// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__27TUk","field":"styles_field__1cFsW","fieldCol":"styles_fieldCol__3ZPnV","diffCol":"styles_diffCol__3sKvH","diff":"styles_diff__1iYNB"};